import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3 } from '@nu-art/thunderstorm-frontend';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_DiseaseProfile, ModuleFE_MultiVar } from '../../../../../../_entity.js';
import { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
import { ICONS, Preview } from '@app/styles';
import { Editor_MultiVar_Description } from '../tabs/Editor_MultiVar_Description/Editor_MultiVar_Description.js';
import './Preview_NewMultiVar.scss';
export class Preview_NewMultiVar extends ComponentSync {
    static show = (diseaseProfileId, selectedDiseaseViewId, onSaveCallback) => {
        const model = {
            key: 'add-new-multi-var',
            className: 'preview-window',
            rect: { ...windowRect.thirdScreen_Middle(), height: undefined },
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Preview_NewMultiVar, { diseaseProfileId: diseaseProfileId, selectedDiseaseViewId: selectedDiseaseViewId, closeCallBack: cb, onSaveCallback: onSaveCallback })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = this.getEditable(nextProps.diseaseProfileId);
        state.editableDP = this.getEditableDP(nextProps.diseaseProfileId);
        return state;
    }
    // ######################## Logic ########################
    getEditable(dpId) {
        return new EditableDBItemV3({
            diseaseProfileId: dpId,
            referenceIds: [],
            variables: [],
        }, ModuleFE_MultiVar)
            .setOnChanged(async () => this.forceUpdate())
            .setDebounceTimeout(200);
    }
    getEditableDP(dpId) {
        const dp = ModuleFE_DiseaseProfile.cache.unique(dpId);
        if (!dp)
            throw new MUSTNeverHappenException(`Could not get DP for id ${dpId}`);
        return new EditableDBItemV3(dp, ModuleFE_DiseaseProfile)
            .setAutoSave(true)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(() => this.forceUpdate())
            .setDebounceTimeout(200);
    }
    saveMV = async () => {
        try {
            const mv = await this.state.editable.save();
            this.props.onSaveCallback?.(mv);
            this.props.closeCallBack();
        }
        catch (err) {
            this.logError(err);
        }
    };
    // ######################## Render ########################
    render() {
        return _jsxs(Preview.Root, { className: 'preview__add-new-multi-var', children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: "Add New MultiVar" }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.closeCallBack }) })] });
    };
    render_Main = () => {
        return _jsx(Preview.Main, { children: _jsxs(Preview.MainColumn, { children: [_jsx(Editor_MultiVar_Description, { editable: this.state.editable, editableDP: this.state.editableDP, defaultDiseaseViewId: this.props.selectedDiseaseViewId, editMode: true }), _jsx(Button, { variant: 'primary', onClick: this.saveMV, disabled: !this.state.editable.item.variables?.length, children: "Save" })] }) });
    };
}
//# sourceMappingURL=Preview_NewMultiVar.js.map